import { render, staticRenderFns } from "./StylePage.vue?vue&type=template&id=6531f11a&scoped=true&"
import script from "./StylePage.vue?vue&type=script&lang=js&"
export * from "./StylePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531f11a",
  null
  
)

export default component.exports